// src/context/AuthContext.jsx

import React, { createContext, useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; 
import * as api from '../api/apiClient';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  
  // ИСПРАВЛЕНИЕ 1: Используем имя 'loading', так как оно используется в App.js
  const [loading, setLoading] = useState(true);
  
  const navigate = useNavigate();

  useEffect(() => {
    const initAuth = async () => {
      try {
        const token = api.getToken();
        if (token) {
          const decodedToken = jwtDecode(token);

          // Проверяем срок действия
          if (decodedToken.exp * 1000 < Date.now()) {
            api.logout();
            setUser(null);
          } else {
            // Устанавливаем пользователя из токена
            // Если вам нужны полные данные (например, email),
            // здесь можно дополнительно вызвать await api.getUserProfile()
            setUser({ login: decodedToken.login, userId: decodedToken.userId });
          }
        }
      } catch (error) {
        console.error("Auth initialization error:", error);
        api.logout();
        setUser(null);
      } finally {
        // ИСПРАВЛЕНИЕ 2: Завершаем загрузку
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  const handleLogin = async (email, password) => {
    // Включаем загрузку на время запроса, чтобы интерфейс не дергался
    try {
      const userData = await api.login(email, password);
      
      // Декодируем токен сразу, чтобы формат данных user был одинаковым
      // (и при входе, и при обновлении страницы)
      const token = api.getToken();
      let userToStore = { login: userData.login, userId: userData.userId };
      
      if (token) {
         const decoded = jwtDecode(token);
         userToStore = { login: decoded.login, userId: decoded.userId };
      }

      setUser(userToStore);
      navigate('/strategies');
    } catch (error) {
      throw error;
    }
  };

  const handleLogout = () => {
    api.logout();
    setUser(null);
    navigate('/login');
  };

  const value = {
    user,
    login: handleLogin,
    logout: handleLogout,
    loading // ИСПРАВЛЕНИЕ 3: Экспортируем именно loading
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
